// frontend/src/api.js
import axios from 'axios';

const baseURL =
  process.env.REACT_APP_API_URL ||
  import.meta.env.VITE_API_URL ||
  'http://localhost:5000';

const api = axios.create({
  baseURL,
});

// تنظیمات پیش‌فرض
api.defaults.headers.common['Content-Type'] = 'application/json';

// --- درخواست: اضافه کردن توکن ---
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // برای آپلود فایل (مثل عکس پروفایل)
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  return config;
});

// --- پاسخ: تمدید خودکار توکن وقتی 401 گرفت ---
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // فقط وقتی 401 گرفت و قبلاً تلاش نکرده باشیم
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem('refreshToken');

      // اگه رفرش توکن نبود → کاربر رو بنداز بیرون
      if (!refreshToken) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('refreshToken');
        window.location.href = '/login_page';
        return Promise.reject(error);
      }

      try {
        // درخواست تمدید توکن
        const res = await axios.post(`${baseURL}/api/auth/refresh-token`, {
          refreshToken,
        });

        const { accessToken, refreshToken: newRefreshToken } = res.data;

        // ذخیره توکن جدید
        localStorage.setItem('authToken', accessToken);
        if (newRefreshToken) {
          localStorage.setItem('refreshToken', newRefreshToken);
        }

        // آپدیت هدر درخواست قبلی
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;

        // دوباره همون درخواست رو بزن (مثلاً دریافت قیمت، موجودی و ...)
        return api(originalRequest);

      } catch (refreshError) {
        console.warn('رفرش توکن نامعتبر یا منقضی شده — خروج اجبار به لاگین');
        localStorage.removeItem('authToken');
        localStorage.removeItem('refreshToken');
        window.location.href = '/login_page';
        return Promise.reject(refreshError);
      }
    }

    // اگه خطای دیگه‌ای بود، همون رو برگردون
    return Promise.reject(error);
  }
);

export default api;